import { fromJS } from 'immutable';
import { getCompanyObject } from './company';

const INITIAL_STATE = fromJS({
  userArea: {
    pathToRedirect: '/',
    error: '',
    loading: false,
    soonBanner: false,
    coupomModal: false,
    messageModal: {
      isVisible: false,
      body: '',
    },
    login: {
      error: '',
      email: '',
      password: '',
      remember: false,
    },
    registration: {
      exists: false,
      error: '',
      name: '',
      email: '',
      password: '',
    },
    taskDetails: {
      error: false,
      loading: null,
      task: {},
      quote: {},
      archiveModal: {
        show: false,
        disabledButton: true,
        reasons: [],
        feedback: null,
        comment: '',
        hasInput: false,
        reasonId: null,
      },
    },
    tasks: [],
    taskQuotes: {
      coupon: {},
      task: {},
      quotes: [],
    },
    proProfile: {
      name: '',
      rating_list: [],
      services: [],
    },
    proRating: [],
    taskCheckout: {
      success: false,
      error: false,
      step: 1,
      quote: {},
      task: {},
      coupon: {},
      cardValidation: {},
      sentCard: false,
      card: {},
      cardList: [],
      installments: 1,
    },
    taskPay: {
      success: false,
      quote: {},
      task: {},
      coupon: {},
      card: {},
      businessTask: {},
      reportProblemModal: {
        show: false,
        disabledButton: true,
        reasons: [],
        feedback: null,
        comment: '',
        hasInput: false,
        reasonId: null,
      },
      successReportModal: {
        show: false,
      },
    },
    messages: {
      error: '',
      loading: false,
      chats: [],
    },
    chat: {
      error: '',
      loading: false,
      quote: {},
      task: {},
      messages: [],
      typingMessage: '',
      socket: null,
      businessProfile: {},
    },
    triiderUser: null,
    paymentMethods: [],
    coupons: [],
    location: [],
  },
});

/**
 * Types
 */
export const Types = {
  LOGOUT: 'userArea/LOGOUT',
  FETCH_TRIIDER_USER: 'userArea/FETCH_TRIIDER_USER',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.LOGOUT: {
      const company_info = getCompanyObject();
      return INITIAL_STATE.setIn(['userArea', 'triiderUser'], fromJS({ company_info }));
    }
    case Types.FETCH_TRIIDER_USER: {
      return state.setIn(['userArea', 'triiderUser'], fromJS(action.payload));
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  logout: () => ({
    type: Types.LOGOUT,
  }),
  fetchTriiderUser: payload => ({
    type: Types.FETCH_TRIIDER_USER,
    payload,
  }),
};
